import {
  MERCADO_PAGO,
  MERCADO_PAGO_FAIL,
  MERCADO_PAGO_SUCCESS,
  SET_ACTUAL_SELECCIONADOS,
  SET_NRO_AFILIADO,
  SET_TURNOS_SELECCIONADOS_LABO,
} from "../ActionTypes";
import axiosLogin from "global/helpers/axiosLogin";
export const setTurnosSeleccionadosLabo = (turnos) => (dispatch) => {
  dispatch({ type: SET_TURNOS_SELECCIONADOS_LABO, payload: turnos });
};

export const setActualNuevoLabo = (actual) => (dispatch) => {
  dispatch({ type: SET_ACTUAL_SELECCIONADOS, payload: actual });
};

export const setNumeroAfiliado = (nroAfiliado) => (dispatch) => {
  dispatch({ type: SET_NRO_AFILIADO, payload: nroAfiliado });
};

export const wsPostValidaOnlineLaboratorio = (dtoTurno) => (nextStep) => {
  axiosLogin().then((respuesta) => {
    respuesta
      .post(`lis/laboratorio/validarOnline`, dtoTurno)
      .then((resp) => {
        if (nextStep && resp?.data) {
          nextStep(true, resp?.data);
        }
      })
      .catch((err) => {
        if (nextStep) {
          nextStep(false, err);
        }
      });
  });
};

export const wsGetValidaOnlineTokenLaboratorio =
  (idProtocolo) => (nextStep) => {
    axiosLogin().then((respuesta) => {
      respuesta
        .get(`lis/laboratorio/VerifaValidarOnLineToken/${idProtocolo}`)
        .then((resp) => {
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          if (nextStep) nextStep(false, { token: true });
        });
    });
  };

export const wsGetMontoLaboratorio = (idProtocolo) => (nextStep) => {
  axiosLogin().then((respuesta) => {
    respuesta
      .get(`lis/laboratorio/montoPresupuesto/${idProtocolo}`)
      .then((resp) => {
        if (nextStep) nextStep(true, 0);
      })
      .catch((err) => {
        if (nextStep) nextStep(false);
      });
  });
};

export const wsGetMercadoPagoLabo = (idProtocolo, nextStep) => (dispatch) => {
  axiosLogin().then((respuesta) => {
    respuesta
      .get(`/lis/laboratorio/${idProtocolo}`)
      .then((resp) => {
        dispatch({ type: MERCADO_PAGO_SUCCESS, payload: resp.data });
        if (nextStep) nextStep(true);
      })
      .catch((err) => {
        dispatch({ type: MERCADO_PAGO_FAIL, payload: err });
        if (nextStep) nextStep(false);
      });
  });
};

export const wsPostAsignarPresenteLabo =
  (idProtocolo, sectorTurno) => (nextStep) => {
    axiosLogin().then((respuesta) => {
      respuesta
        .post(`lis/laboratorio/asignarPresente/${idProtocolo}/${sectorTurno}`)
        .then((resp) => {
          if (nextStep) nextStep(true);
        })
        .catch((err) => {
          if (nextStep) nextStep(false);
        });
    });
  };

export const wsPutNroAfiliado = (valor) => (nextStep) => {
  axiosLogin().then((respuesta) => {
    respuesta
      .put(`v1/paciente/nroAfiliado/${valor}`)
      .then((resp) => {
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        if (nextStep) nextStep(false, err);
      });
  });
};
